import { Stack, Typography } from '@mui/material';
import React from 'react';

import { TGroupContentProps } from '@/console/features/card-layout/components/recent-groups-card/components/group-content/group-content.types';
import { GroupUser } from '@/console/features/card-layout/components/recent-groups-card/components/group-user/group-user';
import { GroupInfo } from '@/console/features/groups/components/group-list/group-info/group-info';
import { GroupSyncStatus } from '@/console/features/groups/components/group-sync-status/group-sync-status';
import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { SearchableResourceField } from '@/shared/components/ui/searchable-resource-field/searchable-resource-field';

export const GroupContent: React.FC<TGroupContentProps> = ({
  group,
  options,
}) => {
  const syncStatus = group?.groupDevicesSyncStatus;

  const getDeviceInformation = () => {
    return syncStatus?.devicesSyncStatus?.map(
      ({ deviceId, deviceName, syncStatusTimestamp, syncStatus }) => {
        return { deviceId, deviceName, syncStatusTimestamp, syncStatus };
      },
    );
  };

  return (
    <>
      <Stack gap="0.625rem" direction="row" minWidth="300px">
        <FolderIcon variant="primary" />
        <Stack gap="0.5rem">
          <Typography variant="p7">
            <SearchableResourceField
              maxLength={16}
              value={group.name}
              queryParam="name"
            />
          </Typography>
          <GroupUser
            creationUser={group.creationUser!}
            updateUser={group.updateUser}
            creationTimestamp={group.creationTimestamp}
            updateTimestamp={group.updateTimestamp}
          />
        </Stack>
      </Stack>
      <Stack
        gap="1rem"
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
      >
        <GroupSyncStatus
          status={syncStatus?.groupSyncStatus}
          deviceInformation={getDeviceInformation()}
        />
        <GroupInfo groupId={group.groupId} />
        {options}
      </Stack>
    </>
  );
};
